exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fading-scroll {\n  position: relative;\n  width: 100%; }\n  .fading-scroll::before, .fading-scroll::after {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 38px;\n    z-index: 2;\n    pointer-events: none; }\n  .fading-scroll::before {\n    top: 0;\n    background-image: linear-gradient(to bottom, white, rgba(255, 255, 255, 0)); }\n  .fading-scroll::after {\n    bottom: 0;\n    background-image: linear-gradient(to top, white, rgba(255, 255, 255, 0)); }\n\n.fading-scroll__scroll {\n  overflow-y: scroll;\n  height: 100%;\n  padding: 30px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/fading_scroll/index.scss
// module id = 2868
// module chunks = 69